/**
 * Concorsando API
 * API per Concorsando
 *
 * OpenAPI spec version: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The EnteVO model module.
* @module model/EnteVO
* @version 2.0.0
*/
export default class EnteVO {
    /**
    * Constructs a new <code>EnteVO</code>.
    * @alias module:model/EnteVO
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>EnteVO</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/EnteVO} obj Optional instance to populate.
    * @return {module:model/EnteVO} The populated <code>EnteVO</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EnteVO();
                        
            
            if (data.hasOwnProperty('id_ente')) {
                obj['id_ente'] = ApiClient.convertToType(data['id_ente'], 'String');
            }
            if (data.hasOwnProperty('ente')) {
                obj['ente'] = ApiClient.convertToType(data['ente'], 'String');
            }
        }
        return obj;
    }

    /**
    * @member {String} id_ente
    */
    'id_ente' = undefined;
    /**
    * @member {String} ente
    */
    'ente' = undefined;




}
